import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { getAttachmentUrl } from 'scripts/domain/services/attachments';
import { multiDownload } from './multidownload';

function AttachmentsDownloadAll({ attachments, orgId, pathPrefix }) {
  const unredactedAttachments = _.filter(attachments, a => !a.isRedacted);
  if (unredactedAttachments.length < 3) {
    return null;
  }

  return (
    <div className="attachments-attachment">
      <div
        className="attachments-attachment-description attachments-attachment-clickable attachments-downloadAll"
        onClick={downloadAll}
      >
        <i className="attachments-downloadAll-icon" />
        Download All
      </div>
    </div>
  );

  function downloadAll(e) {
    e.stopPropagation();
    let urls = _.map(attachments, attachment => getAttachmentUrl(pathPrefix, orgId, attachment));
    multiDownload(urls);
  }
}

AttachmentsDownloadAll.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })).isRequired,
  orgId: PropTypes.string.isRequired,
  pathPrefix: PropTypes.string.isRequired,
};

export default AttachmentsDownloadAll;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/attachment/attachments_download_all.jsx